import React, { useEffect, useState } from 'react';
import { getAdminsList, createAdmin, updateAdminFlags, deleteAdmin } from './adminApi';
import './Admin.css';

export default function Hosts() {
	const [admins, setAdmins] = useState([]);
	const [loading, setLoading] = useState(true);
	const [login, setLogin] = useState('');
	const [password, setPassword] = useState('');
	const [newAccessMedia, setNewAccessMedia] = useState(false);
	const [newAccessSlots, setNewAccessSlots] = useState(true);
	const [saving, setSaving] = useState(false);

	const load = () => {
		getAdminsList()
			.then((d) => setAdmins(d.admins || []))
			.catch((e) => console.error(e))
			.finally(() => setLoading(false));
	};

	useEffect(() => {
		load();
	}, []);

	const handleCreate = async () => {
		const l = login.trim();
		if (!l || !password) {
			alert('Укажите логин и пароль');
			return;
		}
		setSaving(true);
		try {
			await createAdmin({
				login: l,
				password,
				access_media: newAccessMedia,
				access_slots: newAccessSlots,
			});
			setLogin('');
			setPassword('');
			load();
		} catch (e) {
			alert(e.message || 'Ошибка');
		} finally {
			setSaving(false);
		}
	};

	const toggleFlags = async (adm, field, value) => {
		const next = {
			access_media: field === 'access_media' ? value : !!adm.access_media,
			access_slots: field === 'access_slots' ? value : !!adm.access_slots,
		};
		try {
			await updateAdminFlags(adm.id, next);
			setAdmins((prev) =>
				prev.map((a) => (a.id === adm.id ? { ...a, ...next } : a))
			);
		} catch (e) {
			alert(e.message || 'Ошибка');
		}
	};

	const handleDelete = async (adm) => {
		if (!window.confirm(`Удалить ведущего «${adm.login}»?`)) return;
		try {
			await deleteAdmin(adm.id);
			load();
		} catch (e) {
			alert(e.message || 'Ошибка');
		}
	};

	if (loading) {
		return <div style={{ padding: 20 }}>Загрузка…</div>;
	}

	return (
		<div style={{ padding: '20px 0' }}>
			<h3>Ведущие (админы)</h3>
			<p style={{ color: '#666', marginBottom: 16 }}>
				Главный администратор задаёт логин и пароль. Доступ к разделам: Медиа и остальная админка (слоты,
				пользователи, презентации).
			</p>

			<div
				style={{
					marginBottom: 24,
					padding: 16,
					border: '1px solid #eee',
					borderRadius: 8,
					background: '#fafafa',
					maxWidth: 480,
				}}
			>
				<h4 style={{ marginBottom: 12 }}>Новый ведущий</h4>
				<div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
					<input
						className="input_password"
						type="text"
						placeholder="Логин"
						value={login}
						onChange={(e) => setLogin(e.target.value)}
					/>
					<input
						className="input_password"
						type="password"
						placeholder="Пароль"
						value={password}
						onChange={(e) => setPassword(e.target.value)}
					/>
					<label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
						<input
							type="checkbox"
							checked={newAccessMedia}
							onChange={(e) => setNewAccessMedia(e.target.checked)}
						/>
						Доступ к разделу Медиа
					</label>
					<label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
						<input
							type="checkbox"
							checked={newAccessSlots}
							onChange={(e) => setNewAccessSlots(e.target.checked)}
						/>
						Доступ к слотам и остальной админке
					</label>
					<button type="button" className="btn_admin" onClick={handleCreate} disabled={saving}>
						{saving ? 'Создание…' : 'Создать'}
					</button>
				</div>
			</div>

			<h4>Список</h4>
			<div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
				{admins.map((a) => (
					<div
						key={a.id}
						style={{
							display: 'flex',
							flexWrap: 'wrap',
							alignItems: 'center',
							gap: 16,
							padding: 12,
							border: '1px solid #eee',
							borderRadius: 8,
						}}
					>
						<strong style={{ minWidth: 120 }}>{a.login}</strong>
						<label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
							<input
								type="checkbox"
								checked={!!a.access_media}
								onChange={(e) => toggleFlags(a, 'access_media', e.target.checked)}
							/>
							Медиа
						</label>
						<label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
							<input
								type="checkbox"
								checked={!!a.access_slots}
								onChange={(e) => toggleFlags(a, 'access_slots', e.target.checked)}
							/>
							Слоты / админка
						</label>
						<button
							type="button"
							className="btn_admin"
							style={{ background: '#c0392b', marginLeft: 'auto' }}
							onClick={() => handleDelete(a)}
						>
							Удалить
						</button>
					</div>
				))}
				{admins.length === 0 && <p style={{ color: '#888' }}>Пока никого нет</p>}
			</div>
		</div>
	);
}
